/**
 * App Theme - Sizes
 *
 * React Native Starter App
 * https://github.com/mcnamee/react-native-starter-app
 */
import { Platform } from "react-native";
import i18n from "../i18n";

import Dimensions from "react-native-web-dimension-helper";

const { width, height } = Dimensions.get("window");
const screenHeight = width < height ? height : width;
const screenWidth = width < height ? width : height;
const languageCode = i18n.language;

export default {
    // Window Dimensions
    screen: {
        height: screenHeight,
        width: screenWidth,

        widthHalf: screenWidth * 0.5,
        widthThird: screenWidth * 0.333,
        widthTwoThirds: screenWidth * 0.666,
        widthQuarter: screenWidth * 0.25,
        widthThreeQuarters: screenWidth * 0.75,
        widthNinetyPercent: screenWidth * 0.9,
    },
    navbarHeight: (Platform.OS === "ios") ? 64 : 54,
    statusBarHeight: (Platform.OS === "ios") ? 16 : 0,
    tabbarHeight: 51,

    padding: 20,
    paddingSml: 10,
    paddingXs: 5,

    borderRadius: 2,

    sectionHeight: 30,

    headerPadding: (Platform.OS === "ios") ? 15 : 0,

    paddingPA: (Platform.OS === "ios") ? 15 : ((languageCode === "th") ? 0 : 7),
    paddingP: (Platform.OS === "ios") ? 15 : 10,
    paddingSmlPL: (languageCode === "th" ? ((Platform.OS === "ios") ? 5 : 10) : ((Platform.OS === "ios") ? 5 : 10)),
    paddingXsPL: (languageCode === "th" ? 0 : ((Platform.OS === "ios") ? 3 : 5)),


    iconLg: (Platform.OS === "ios") ? 38 : 35,

    avatarText: (Platform.OS === "ios") ? 20 : 17,

    xLargeAvatarText: (Platform.OS === "ios") ? 90 : 87,
};
